import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AdminsettingRoutingModule } from './adminsetting-routing.module';
import { AdminModule } from '../admin/admin.module';
import { FormsModule } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { SettingComponent } from './setting/setting.component';
import { StaffUserTypeMapComponent } from './staff-user-type-map/staff-user-type-map.component';
import { AddRoleComponent } from './add-role/add-role.component';
import { StaffLoginComponent } from './staff-login/staff-login.component';
import { RolePermisionComponent } from './role-permision/role-permision.component';
import { ClassTeacherAccessMapComponent } from './class-teacher-access-map/class-teacher-access-map.component';
import { StudentLoginComponent } from './student-login/student-login.component';
import { LoginReportComponent } from './login-report/login-report.component';
import { DashboardAccessComponent } from './dashboard-access/dashboard-access.component';
import { ChangePasswordComponent } from './change-password/change-password.component';


@NgModule({
  declarations: [SettingComponent, StaffUserTypeMapComponent, AddRoleComponent, StaffLoginComponent, RolePermisionComponent, ClassTeacherAccessMapComponent, StudentLoginComponent, LoginReportComponent, DashboardAccessComponent, ChangePasswordComponent],
  imports: [
    CommonModule,
    AdminsettingRoutingModule,
    AdminModule,
    FormsModule,
    BsDatepickerModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot()
  ]
})
export class AdminsettingModule { }
